export default __webpack_public_path__ + "static/media/hht2_ep13_timeline_q01_b.c984813c.png";